/**
 * useIntegratedAccess.js — 작업 대상 "통합관리" 판단 묶음 (2026-10-02, CompanyScopeContext.jsx 292줄에서 분리 — 동작 변화 없음)
 *
 *   integratedMenus  : 운영자는 고른 테넌트 회사 안의 메뉴만, 그 외는 내 열쇠 목록 그대로(scopedIntegratedMenus)
 *   canUseIntegrated : 보일 통합 메뉴가 1개 이상, 또는 '통합 메뉴 관리' 열쇠(manageKey)
 *   integratedReady  : 들어가기 확인(IntegratedHomeRoute)이 기다리는 값 — 목록 도착 + (운영자) 테넌트 회사 목록 도착
 *                      + 열쇠 판단 도착(manageReady — 운영자가 고른 고객 테넌트의 관리자 열쇠)
 *   integrated       : 지금 통합 모드인가 = 통합 주소 + 쓸 수 있음
 *   canSeeHome       : 빠져나올 때 홈(/admin/home)으로 갈 수 있나 — 운영자·HOME 열쇠
 *   selectIntegrated : 회사 칸의 "통합관리" — 통합 관리 홈으로 가기만 한다(회사값·저장소·서버 회사값은 그대로)
 */
import { useCallback, useMemo } from 'react';
import { INTEGRATED_HOME_PATH, isIntegratedPath, scopedIntegratedMenus } from './integratedScope';

// manageKey(2026-10-15): 운영자가 아닌 '통합 메뉴 관리' 열쇠 보유자(테넌트 관리자 등) — 메뉴가 0개여도 통합관리를 골라
//   처음 메뉴를 만들 수 있어야 한다(사용자: "테넌트 관리자에게는 통합관리에 통합 메뉴 설정이 보여야 맞다").
//   2026-10-24: 운영자가 고객 테넌트를 고르면 그 테넌트 관리자의 같은 열쇠가 들어온다(CompanyScopeContext — 관리자와 똑같이).
export function useIntegratedAccess({
  isOperator, integratedList, listReady, ledgerCompanies, pathname, homeKey, navigate, manageKey = false, manageReady = true,
}) {
  const integratedMenus = useMemo(() => scopedIntegratedMenus({
    isOperator,
    list: integratedList.list,
    tenantCompanyCodes: isOperator && listReady ? ledgerCompanies.map((c) => c.code) : null,
  }), [isOperator, integratedList.list, listReady, ledgerCompanies]);
  const canUseIntegrated = integratedMenus.length > 0 || Boolean(manageKey);
  const integratedReady = integratedList.loaded && listReady && manageReady;
  const integrated = canUseIntegrated && isIntegratedPath(pathname);
  const canSeeHome = isOperator || homeKey;

  const selectIntegrated = useCallback(() => {
    if (!isIntegratedPath(pathname)) navigate(INTEGRATED_HOME_PATH);
  }, [pathname, navigate]);

  return { integratedMenus, canUseIntegrated, integratedReady, integrated, canSeeHome, selectIntegrated };
}
